/**
 * DevExtreme (esm/ui/list.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import List from "./list_light";
import "../__internal/ui/list/modules/selection";
import "../__internal/ui/list/modules/deleting";
import "../__internal/ui/list/modules/dragging";
import "../__internal/ui/list/modules/context";
import "../__internal/ui/list/modules/search";
export default List;